import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, TextField } from '@mui/material';
import { AuthFrame } from './AuthFrame';
import { OtpFields } from './OtpFields';
import { authApi } from '../../core/api/client';
import { ROUTES } from '../../app/routes';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [verification, setVerification] = useState({ email: '', challengeId: '', code: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  return <AuthFrame title="Reset password">
    <h1>Reset password</h1>
    <p className="lead">Verify your email to choose a new password.</p>
    {error && <Alert severity="error">{error}</Alert>}
    {done ? <Alert severity="success">Password updated. Sign in with your new password.</Alert> :
      <Box component="form" onSubmit={async event => {
        event.preventDefault(); setError('');
        if (password.length < 10 || password.length > 1024) { setError('Use a password of 10 to 1024 characters.'); return; }
        if (password !== confirm) { setError('Passwords do not match.'); return; }
        if (verification.email !== email || !verification.challengeId || !/^\d{6}$/.test(verification.code)) { setError('Request and enter the email verification code.'); return; }
        setBusy(true);
        try { await authApi.resetPassword({ email, password, challengeId: verification.challengeId, code: verification.code }); setDone(true); }
        catch (caught) { setError(caught instanceof Error ? caught.message : 'Password reset failed.'); }
        finally { setBusy(false); }
      }}>
        <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required fullWidth margin="normal" disabled={busy} />
        <OtpFields email={email} purpose="PasswordReset" busy={busy} onChange={setVerification} />
        <TextField label="New password" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required fullWidth margin="normal" disabled={busy} helperText="At least 10 characters" />
        <TextField label="Confirm password" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" required fullWidth margin="normal" disabled={busy} />
        <button type="submit" className="ax-primary" disabled={busy}>{busy ? 'Updating�' : 'Reset password'}</button>
      </Box>}
    <p className="ax-foot"><Link to={ROUTES.login}>Back to sign in</Link></p>
  </AuthFrame>;
}
